module.exports = __webpack_public_path__ + "img/symbol_16.16687c4a.png";